<!--
 * @Description: 教职工详情 专著、教材、教参
 * @Author: 张天伟
 * @Date: 2023-03-08 17:11:45
 * @LastEditors: 张天伟
 * @LastEditTime: 2023-03-09 14:02:05
-->

<template>
  <div>
    <el-descriptions v-for="(item, index) in tableData" :key="index" :column="4" border>
        <el-descriptions-item label="论著类别" label-align="right" align="left" width="150px" span="2">{{item.lzlbbt}}</el-descriptions-item>
        <el-descriptions-item label="著作中文名" label-align="right" align="left" width="150px" span="2">{{item.zzzwm}}</el-descriptions-item>
        <el-descriptions-item label="ISBN 号" label-align="right" align="left" width="150px" span="2">{{item.isbn}}</el-descriptions-item>
        <el-descriptions-item label="出版日期" label-align="right" align="left" width="150px" span="2">{{item.cbrq}}</el-descriptions-item>
        <el-descriptions-item label="书籍作者" label-align="right" align="left" width="150px" span="2">{{item.sjzz}}</el-descriptions-item>
        <el-descriptions-item label="书籍总字数" label-align="right" align="left" width="150px" span="2">{{item.sjzzs}}</el-descriptions-item>
        <el-descriptions-item label="出版社" label-align="right" align="left" width="150px" span="2">{{item.cbs}}</el-descriptions-item>
        <el-descriptions-item label="著作英文名" label-align="right" align="left" width="150px" span="2">{{item.zzywm}}</el-descriptions-item>
        <el-descriptions-item label="本人负责部分字数" label-align="right" align="left" width="150px" span="2">{{item.brfzbfzs}}</el-descriptions-item>
        <el-descriptions-item label="本人角色" label-align="right" align="left" width="150px" span="2">{{item.brjs}}</el-descriptions-item>
      </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = { url: '/api/v2/renliziyuan/jiaozhigongzhuanzhujiaocaijiaocan/list', data: { id: props.row.id, order: 'gh', sort: 'asc' } }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
